/* eslint-disable no-useless-escape */
import { useSelector } from 'react-redux';
import Link from 'next/link';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { ButtonGroup } from '@r1-frontend/ui-react/components/buttons/buttonGroup/ButtonGroup';
import { H3 } from '@r1-frontend/ui-react/components/typography/heading';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import TextWrapper from '@r1-frontend/ui-react/components/typography/TextWrapper';
import WebpImage from '@r1-frontend/ui-react/components/WebpImage';
import Section from '@r1-frontend/ui-react/experimental/blocks/section';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import CallbackForm from '~/src/features/contact/components/CallbackForm';
import { APP_IMG_SRC, SOCIALS } from '~/src/features/contact/constants';
import { getCurrentCity } from '~/src/store/selectors/city';

import { Container } from '~/src/features/contact/components/Header/styled';
import * as ST from './styled';

const Content = () => {
    const { callCenter } = useSelector(getCurrentCity);

    return (
        <Section>
            <Container>
                <ST.Grid>
                    <ST.Support indent={{ $united: [24] }} rounder={{ $radius: 32 }}>
                        <TextWrapper>
                            <H3>Cлужба поддержки</H3>
                            <ST.SControlElement as='a' href={`tel:${callCenter.replace(/[^0-9\+]/g, '')}`} $customFont={FONTS.MediumXS}>{callCenter}</ST.SControlElement>
                        </TextWrapper>
                    </ST.Support>
                    <ST.Socials indent={{ $united: [24] }} rounder={{ $radius: 32 }}>
                        <H3>Напишите нам в&nbsp;соцсетях</H3>
                        <ST.SocialsList socials={SOCIALS} />
                    </ST.Socials>
                    <ST.Callback indent={{ $united: [24] }} rounder={{ $radius: 32 }}>
                        <CallbackForm>
                            <ST.TextContent>
                                <H3>Закажите обратный звонок</H3>
                                <Paragraph4 $smaller>
                                    Проконсультируем по&nbsp;любому вопросу, поможем определиться с&nbsp;тарифом или просто поболтаем.
                                </Paragraph4>
                            </ST.TextContent>
                        </CallbackForm>
                    </ST.Callback>
                    <ST.App indent={{ $united: [24] }} rounder={{ $radius: 32 }}>
                        <ST.AppContent>
                            <ST.TextContent>
                                <H3>Напишите в&nbsp;поддержку на&nbsp;сайте или в&nbsp;приложении</H3>
                                <Paragraph4 $smaller>
                                    Создать обращение в&nbsp;поддержку можно на&nbsp;сайте в&nbsp;вашем{' '}
                                    <Link href='/lk' passHref>
                                        <ST.SControlElement as='a' $customFont={FONTS.MediumXS}>личном кабинете</ST.SControlElement>
                                    </Link>
                                    . Или написать нам в&nbsp;чате приложения.
                                </Paragraph4>
                            </ST.TextContent>
                            <a href='https://app.dom.ru/contacts' target='_blank' rel='noreferrer'>
                                <ButtonGroup>
                                    <Button bType='primary'>
                                        Скачать приложение
                                    </Button>
                                </ButtonGroup>
                            </a>
                        </ST.AppContent>
                        <ST.ImageWrapper>
                            <WebpImage urlWebp={`${APP_IMG_SRC}.webp`}>
                                <img
                                    src={`${APP_IMG_SRC}.png`}
                                    alt='Изображение мобильного телефона с приложением Дом.ру и qr-кодом'
                                    data-test='app-image'
                                />
                            </WebpImage>
                        </ST.ImageWrapper>
                    </ST.App>
                </ST.Grid>
            </Container>
        </Section >
    );
};

export default Content;
